import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { PAGE_DATA_TYPES } from '../utils';
import { Button } from '../../components/widgets';
import TextField from '../../components/molecules/TextField';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import css from './RequestIntegrationForm.css';

// The "Request a data connector" form shown inside the Add Data Connector dropdown after
// the user clicks "Request this integration". On submit the request is reported to
// Mixpanel by the caller via onSubmit — per AN10-1087 the data is saved via Mixpanel only.
const RequestIntegrationForm = ({
    initialName = '',
    translationPageKey = PAGE_DATA_TYPES.DATA_SOURCES,
    onBack = () => {},
    onCancel = () => {},
    onSubmit = () => {},
}) => {
    const prefix = `STATIC.PAGES.${translationPageKey}`;
    const [name, setName] = useState(initialName);
    const [website, setWebsite] = useState('');
    const [additionalDetails, setAdditionalDetails] = useState('');

    const trimmedName = name.trim();

    const handleSubmit = () => {
        if (!trimmedName) {
            return;
        }
        onSubmit({ name: trimmedName, website: website.trim(), additionalDetails: additionalDetails.trim() });
    };

    return (
        <div className={css.form}>
            <button type="button" className={css.backLink} onClick={onBack}>
                <Icon name="chevron-left" size={IconSizes.SMALL} variant={IconVariants.ACTIVE} interactive={false} />
                <Translate id={`${prefix}.REQUEST_INTEGRATION_BACK`} />
            </button>

            <div className={css.title}>
                <Translate id={`${prefix}.REQUEST_INTEGRATION_FORM_TITLE`} />
            </div>
            <div className={css.description}>
                <Translate id={`${prefix}.REQUEST_INTEGRATION_FORM_DESCRIPTION`} />
            </div>

            <TextField
                label={`${prefix}.REQUEST_INTEGRATION_NAME_LABEL`}
                mandatory
                value={name}
                onChange={setName}
                containerClass={css.field}
            />
            <TextField
                label={`${prefix}.REQUEST_INTEGRATION_WEBSITE_LABEL`}
                placeholder={`${prefix}.REQUEST_INTEGRATION_WEBSITE_PLACEHOLDER`}
                value={website}
                onChange={setWebsite}
                containerClass={css.field}
            />
            <TextField
                label={`${prefix}.REQUEST_INTEGRATION_DETAILS_LABEL`}
                placeholder={`${prefix}.REQUEST_INTEGRATION_DETAILS_PLACEHOLDER`}
                type="textarea"
                value={additionalDetails}
                onChange={setAdditionalDetails}
                containerClass={css.field}
            />

            <div className={css.actions}>
                <Button
                    type="secondary"
                    level="level1"
                    text={`${prefix}.REQUEST_INTEGRATION_CANCEL`}
                    onClick={onCancel}
                />
                <Button
                    type="primary"
                    level="level1"
                    text={`${prefix}.REQUEST_INTEGRATION_SUBMIT`}
                    onClick={handleSubmit}
                    disabled={!trimmedName}
                />
            </div>
        </div>
    );
};

RequestIntegrationForm.propTypes = {
    initialName: PropTypes.string,
    translationPageKey: PropTypes.string,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default RequestIntegrationForm;
